import { withReduxStateSync } from 'redux-state-sync';

import { combineReducers } from 'redux';
import previewReducer from './preview/previewSlice';
import userReducer from './user/userSlice';
const rootReducer = combineReducers({
  user: userReducer,
  preview: previewReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default withReduxStateSync(rootReducer);
